import { api } from './api';

export interface TutorCanvasState {
  blocks: string | null;
  updatedAt: string | null;
  publishedAt: string | null;
  hasUnpublishedChanges: boolean;
}

export interface PublishedCanvas {
  blocks: string;
  publishedAt: string;
}

/**
 * Publish model (spec 046 FR-033..036, contracts/publish-contract.md). Saving a tutor
 * canvas is always private; only publish() makes content reachable by students.
 */
export async function publishCanvas(courseId: number, nodeId: number): Promise<{ publishedAt: string }> {
  const response = await api.post<{ data: { publishedAt: string } }>(
    `/api/tutor/courses/${courseId}/nodes/${nodeId}/canvas/publish`
  );
  return response.data.data;
}

export async function getTutorCanvasState(courseId: number, nodeId: number): Promise<TutorCanvasState | null> {
  try {
    const response = await api.get<{ data: TutorCanvasState }>(
      `/api/tutor/courses/${courseId}/nodes/${nodeId}/canvas`
    );
    return response.data.data ?? null;
  } catch (err: any) {
    if (err?.response?.status === 204) return null;
    throw err;
  }
}

/** Student read of the published snapshot; null when the topic has never been published. */
export async function getPublishedCanvas(courseId: number, nodeId: number): Promise<PublishedCanvas | null> {
  try {
    const response = await api.get<{ data: PublishedCanvas }>(
      `/api/student/courses/${courseId}/nodes/${nodeId}/published-canvas`
    );
    return response.data.data ?? null;
  } catch (err: any) {
    if (err?.response?.status === 204) return null;
    throw err;
  }
}
